import { Box, createStyles, makeStyles, styled, Theme } from '@material-ui/core';
import { COLORS } from 'shared/constants/COLORS';
const { DARK_TEXTBOX_BACKGROUND, LIGHT_TEXTBOX_BACKGROUND } = COLORS;

export const useStyles = makeStyles((theme) =>
  createStyles({
    linkField: {
      '& .MuiInputBase-root': {
        backgroundColor:
          theme.palette.type === 'dark'
            ? `${DARK_TEXTBOX_BACKGROUND} !important `
            : `${LIGHT_TEXTBOX_BACKGROUND} !important `,
      },
    },
  }),
);

export const CopyAndShareContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: '10px',
  fontSize: 16,
  alignItems: 'center',
  justifyContent: 'end',
  [theme.breakpoints.up('md')]: {
    justifyContent: 'start',
  },
}));
